import { handleService } from './common'

export default {
  GetNodeTable (data) {
    let url = '/api/Device/GetNodeEquListByPgae'
    // debugger
    return handleService(url, data)
  },

  // 故障状态查询
  GetStatus (data) {
    console.log(data)
  }
}
